import {camelCase, map, isObject, chain, isArray} from 'lodash';

export const objToCamelCase = <T>(obj: any): T => {
  return chain(obj)
    .mapKeys((value, key) => camelCase(key))
    .mapValues((value) => {
      if (isArray(value))
        return objsToCamelCase(value);
      else if (isObject(value))
        return objToCamelCase(value);
      else
        return value;
    })
    .value();
};

export const objsToCamelCase = <T>(objs: any[]): T[] => {
  if (isArray(objs))
    return map(objs, (obj) => objToCamelCase(obj));
  else if (isObject(objs))
    return objToCamelCase(objs);
  else
    return objs;
};
